import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Col, Form, Input, Label, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Address, AddressRequired, CheckMeOut, CheckoutRequired, CityRequired, Country, EmailAddress, EmailRequired, FirstName, FirstNameRequired, LastName, LastNameRequired, Phone, PhoneRequired, PincodeRequired, PlaceOrder, PostalCode, StateCountry, StateRequired, TownCity } from "../../../../Constants/Constants";
import { CheckoutFormType } from "../../../../Types/EcommerceType";

const CheckoutForm = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<CheckoutFormType>();

  const onSubmit: SubmitHandler<CheckoutFormType> = (data) => {
    if (data !== undefined) navigate(`${process.env.PUBLIC_URL}/invoice/invoice_1`);
    reset();
  };

  return (
    <Col xl="6" sm="12">
      <Form onSubmit={handleSubmit(onSubmit)} className="form-bookmark needs-validation">
        <Row>
          <Col sm="6" className="mb-3">
            <Label for="inputEmail4">{FirstName}</Label>
            <input className="form-control" type="text" {...register("firstName", { required: true })} />
            {errors.firstName && <span className="text-danger">{FirstNameRequired}</span>}
          </Col>
          <Col sm="6" className="mb-3">
            <Label for="inputPassword4">{LastName}</Label>
            <input className="form-control" type="text" {...register("lastName", { required: true })} />
            {errors.lastName && <span className="text-danger">{LastNameRequired}</span>}
          </Col>
        </Row>
        <Row>
          <Col sm="6" className="mb-3">
            <Label for="inputEmail5">{Phone}</Label>
            <input className="form-control" type="number" {...register("phone", { required: true })} />
            {errors.phone && <span className="text-danger">{PhoneRequired}</span>}
          </Col>
          <Col sm="6" className="mb-3">
            <Label for="inputPassword7">{EmailAddress}</Label>
            <input className="form-control" type="text" {...register("email", { required: true, pattern: /^\S+@\S+$/i })} />
            {errors.email && <span className="text-danger">{EmailRequired}</span>}
          </Col>
        </Row>
        <div className="mb-3">
          <Label for="inputState">{Country}</Label>
          <Input type="select" id="inputState" defaultValue={"Choose..."}>
            <option>Choose...</option>
            <option>...</option>
          </Input>
        </div>
        <div className="mb-3">
          <Label for="inputAddress5">{Address}</Label>
          <input className="form-control" type="text" {...register("address", { required: true, min: 20, max: 120 })} />
          {errors.address && <span className="text-danger">{AddressRequired}</span>}
        </div>
        <div className="mb-3">
          <Label for="inputCity">{TownCity}</Label>
          <input className="form-control" type="text" {...register("city", { required: true })} />
          {errors.city && <span className="text-danger">{CityRequired}</span>}
        </div>
        <div className="mb-3">
          <Label for="inputAddress2">{StateCountry}</Label>
          <input className="form-control" type="text" {...register("state", { required: true })} />
          {errors.state && <span className="text-danger">{StateRequired}</span>}
        </div>
        <div className="mb-3">
          <Label for="inputAddress6">{PostalCode}</Label>
          <input className="form-control" type="text" {...register("pincode", { pattern: /\d+/ })} />
          {errors.pincode && <span className="text-danger">{PincodeRequired}</span>}
        </div>
        <div className="mb-3">
          <input type="checkbox" className="form-check-input" {...register("chech", { required: true })} />
          <Label className="m-0">{CheckMeOut}</Label>
          {errors.chech && <span className="text-danger mt-0">{CheckoutRequired}</span>}
        </div>
        <div className="text-end order-place mb-3">
          <Btn color="primary" type="submit">
            {PlaceOrder}
          </Btn>
        </div>
      </Form>
    </Col>
  );
};

export default CheckoutForm;
